jQuery.fn.isVisibleTop = function(offset) {
  const $window = jQuery(window);
  const $this = jQuery(this);
  const topView = $window.scrollTop();
  const botView = topView + $window.height();
  const topElement = $this.offset().top;

  return ((topElement <= botView + offset));
}

jQuery.fn.setStartOnVisibleTop = function() {
  jQuery(this).each((index, element) => {
    const $element = jQuery(element);
    $element.toggleClass('start', $element.isVisibleTop(-20));
  });
};

jQuery(document).ready(() => {

  jQuery('body').removeClass('preload');

  const $startOnVisible = jQuery('.typewriter, .transition-opacity:not(.start), .transition-block-reveal:not(.start)');

  $startOnVisible.setStartOnVisibleTop();
  jQuery(window).scroll(event => {
    $startOnVisible.setStartOnVisibleTop();
  });


  const $archiveYear = jQuery('.archive-year-column .section-title-rotated');
  if($archiveYear.length){
    const $window = jQuery(window);
    const $content = jQuery('#content');
    
    let contentTop = $content.offset().top;

    jQuery(window).on('resize', () => {
      contentTop = $content.offset().top;
      jQuery(window).scroll();
    });

    $archiveYear.each((index, element) => {
      const $element = jQuery(element);
      const $parent = $element.parent();

      const originalTop = $element.position().top;
      $window.scroll(() => {
        const parentTop = $parent.offset().top;
        const parentHeight = $parent.outerHeight();
        const windowTop = $window.scrollTop();

        let top = Math.max(originalTop, windowTop - parentTop + contentTop + 16);
        top = Math.min(top, parentHeight);

        $element.css('top', top + 'px');
      });
      
    });

    jQuery(window).scroll();

  }

});